export default {
  session: {
    __typename: 'AuthPayload',
    token: null,
    user: null
  }
}

